import type { FC } from 'react';

import { useUpdateAccountAnalyticsSettings } from '@zen/Accounts/AccountForms/hooks/useUpdateAccountAnalyticsSettings';
import { Switch } from '@zen/DesignSystem';
import useAccount from '@zen/utils/hooks/useAccount';

import type { AccountAnalyticsSettings } from '../types';

interface Props {
  settings: Omit<AccountAnalyticsSettings, 'analyticsUserId' & 'accountId'>;
}

const AnalyticsSharedUserSettingToggle: FC<Props> = ({ settings }) => {
  const { accountUuid: accountId } = useAccount();
  const { handleUpdateAccountAnalyticsSettings, loading } = useUpdateAccountAnalyticsSettings();
  const { analyticsEnabled, analyticsSharedUserEnabled } = settings;

  const handleChange = async (isChecked: boolean): Promise<void> => {
    await handleUpdateAccountAnalyticsSettings(accountId, {
      analyticsEnabled,
      analyticsSharedUserEnabled: isChecked
    });
  };

  return (
    <div data-testid="analytics-shared-user-setting-toggle">
      <Switch
        label="Shared credentials for analytics"
        labelHint="This will allow simplified login to the analytics dashboard by using a shared login."
        isChecked={analyticsSharedUserEnabled}
        onChange={handleChange}
        isDisabled={loading || !analyticsEnabled}
      />
    </div>
  );
};

export default AnalyticsSharedUserSettingToggle;
